import React, {useEffect, useRef, useState} from 'react';
import {useField, useFormikContext} from 'formik';
import {Form} from "react-bootstrap";

import * as select from 'tail.select';

import {useTranslation} from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";
import {useDispatch, useSelector} from "react-redux";

export default function DynamicSelectField(props) {
  let {label, placeholder, init, listName, onChanged, optionsMappingFunc, resultMappingFunc, ...rest} = props;

  const {values, setFieldValue} = useFormikContext();

  const listItems = useSelector(state => state.lists[listName])
  const [options, setOptions] = useState([]);

  const [field, meta, helper] = useField(props);
  const dispatch = useDispatch();
  const {setValue} = helper;
  const {summaryMode} = rest;

  const fieldRefClass = 'select-' + field.name;
  const {t} = useTranslation();

  const SelectFieldObject = useRef(null);

  useEffect(() => {
    let mappingFunction = optionsMappingFunc;
    if (!mappingFunction) {
      mappingFunction = items => items;
    }
    setOptions(mappingFunction(listItems));
  }, [listItems, optionsMappingFunc]);

  useEffect(() => {
    const _onChange = (item) => {
      setValue(item.key);
    }
    if (!summaryMode) {
      const actSelect = () => {
        try {
          SelectFieldObject.current = select('.' + fieldRefClass, {
            classNames: "gcap-tail-select default",     // For our demonstration only
            descriptions: true,
            placeholder: placeholder,
            locale: "it",
            search: true,
            width: "100%",
          })
          if (SelectFieldObject.current) {
            SelectFieldObject.current.on("change", _onChange);
          }
        } catch (error) {
          console.log('Cannot rendered field' + fieldRefClass)
        }
      }
      actSelect();
      return () => {
        document.removeEventListener('DOMContentLoaded', actSelect);
      };
    }
    // eslint-disable-next-line
  }, [fieldRefClass, placeholder]);

  useEffect(() => {
    if (init) {
      init(dispatch);
    }
  }, [init, dispatch]);

  useEffect(() => {
    console.log('OPTIONS: ', options);
    SelectFieldObject.current.config("items", options);
  }, [options]);

  useEffect(() => {
    console.log('Field.value = ', field.value);
    if (onChanged && field.value) {
      onChanged(resultMappingFunc(field.value, listItems), dispatch, values, setFieldValue);
    }
    // eslint-disable-next-line
  }, [field.value, dispatch, onChanged, resultMappingFunc]);

  return (
    <Form.Group className={(meta.touched && meta.error) ? 'has-error' : ''}>
      {!summaryMode ? (
          <>
            <div>
              <Form.Label htmlFor="disabledSelect">{label}</Form.Label>
            </div>

            <div>{JSON.stringify(field.value)}</div>
            <Form.Control as="select"
                          className={`${fieldRefClass} ${(meta.touched && meta.error) ? 'is-invalid' : ''}`} {...field}
                          value={field.value}>

              {(options || []).map(option => {
                let properLabel = option.label;
                if (typeof option.label === 'object' && option.label.props && option.label.props.i18nKey) {
                  properLabel = t(option.label.props.i18nKey);
                }
                return <option value={option.value} key={field.name + '__' + option.value}>{properLabel}</option>
              })}
            </Form.Control>

            {(meta.touched && meta.error) &&
            <div className="invalid-feedback" style={{display: 'block'}}>{meta.error}</div>}
          </>
        ) : (
          <>
            <span className="paragraph-small-fs9">{label}</span>
            <div>{JSON.stringify(field.value)}</div>
             <SummaryItem value={field.value} error={meta.error}/>
          </>
        )
      }

    </Form.Group>
  );
}
